import { useState } from 'react';
import { UserCheck } from 'lucide-react';

export const BulkReferral = ({ ids, referrals, api, onDone }) => {
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const apply = async () => {
    const label = code ? (referrals.find(([c]) => c === code)?.[1] || code) : 'Direct / no referral';
    if (!window.confirm(`Set "Referred by" to ${label} for ${ids.length} student(s)? Each change is logged in the student's history.`)) return;
    setBusy(true); setMsg('');
    const d = await api('/students/bulk-referral', { method: 'POST', body: JSON.stringify({ member_ids: ids, referral_code: code }) }, true);
    setBusy(false);
    if (d.error) { setMsg(d.error); return; }
    onDone(`Referred by set to ${label} for ${d.updated} student(s)${d.unchanged ? ` (${d.unchanged} already had it)` : ''}${d.not_found ? ` · ${d.not_found} not found` : ''}.`);
  };
  return (
    <div className="flex items-center gap-2" data-testid="bulk-referral">
      <select value={code} onChange={(e) => setCode(e.target.value)} className="h-9 rounded-full bg-white/10 border border-white/20 text-sm px-3 text-white" data-testid="bulk-referral-select">
        <option value="" className="text-slate-900">Direct / no referral</option>
        {referrals.map(([c, l]) => <option key={c} value={c} className="text-slate-900">{l}</option>)}
      </select>
      <button type="button" disabled={busy} onClick={apply} className="inline-flex items-center gap-1.5 rounded-full bg-white text-[#0b1f4d] text-sm font-semibold px-4 py-2 disabled:opacity-50" data-testid="bulk-referral-apply-btn">
        <UserCheck className="w-4 h-4" />{busy ? 'Saving…' : 'Set Referred by'}
      </button>
      {msg && <span className="text-xs text-red-200" data-testid="bulk-referral-error">{msg}</span>}
    </div>
  );
};
